import { createRouter, createWebHistory } from 'vue-router'
import store from '../store'
import { ElMessage } from 'element-plus'
import Admin from '@/views/Admin.vue'

const routes = [
  {
    path: '/',
    name: 'Admin',
    component: Admin,
    meta: { requiresAuth: true }
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/telegram-login',
    name: 'TelegramLogin',
    component: () => import('../views/TelegramLogin.vue'),
    meta: { requiresAuth: false }
  },
  // {
  //   path: '/register',
  //   name: 'Register',
  //   component: () => import('../views/Register.vue'),
  //   meta: { requiresAuth: false }
  // }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach(async (to, from, next) => {
  const token = store.state.token
  const user = store.state.user

  // 检查用户是否被禁用
  if (user && user.role > 2) {
    store.dispatch('logout')
    next('/telegram-login')
    ElMessage.error('账号已被禁用,请联系管理员')
    return
  }

  // 如果需要登录认证
  if (to.meta.requiresAuth) {
    // 如果有token但没有用户信息，尝试恢复用户信息
    if (token && !user) {
      try {
        // 这里可以调用API验证token并获取用户信息
        // 但由于我们已经将用户信息存储在localStorage中，直接使用即可
        const storedUser = JSON.parse(localStorage.getItem('user'))
        if (storedUser) {
          store.commit('setUser', storedUser)
          next()
          return
        }
      } catch (error) {
        console.error('恢复用户信息失败:', error)
      }
    }

    // 如果没有token或用户信息，跳转到登录页
    if (!token || !user) {
      next('/telegram-login')
      return
    }

    // 检查用户是否已选择群组
    const groupId = user.groupId || localStorage.getItem('groupId');
    if (!groupId || groupId === '0') {
      // 如果未选择群组，允许访问首页（仪表盘会显示群组选择弹窗）
      if (to.path === '/') {
        next()
        return
      }
      // 其他需要群组的页面，重定向到首页
      next('/')
      return
    }
  }

  // 如果已登录用户访问登录页，重定向到首页
  if ((to.path === '/login' || to.path === '/telegram-login') && token && user) {
    next('/')
    return
  }

  next()
})

export default router
